import React from "react";
import { Button } from '@amzn/alchemy-components-react';

// Alchemy has no built-in destructive variant — flag the confirm action with the error-alert token.
const destructiveButtonStyle: React.CSSProperties = {
    borderColor: 'var(--color-base-error-alert, #c00)',
    color: 'var(--color-base-error-alert, #c00)',
};

// Vertical stack, primary (destructive) action on top, neutral "keep" below.
const ACTION_STACK_CLASS = 'd-flex flex-column align-items-center';

export interface ConfirmActionDialogProps {
    /** Bold prompt line. */
    title: string;
    /** Muted explanatory line. */
    body: string;
    confirmLabel: string;
    keepLabel: string;
    /** Fires when the user confirms the destructive action. */
    onConfirm: () => void;
    /** Fires when the user backs out (keeps things as they are). */
    onKeep: () => void;
    /** Disables the confirm button while an operation is in flight. */
    submitting?: boolean;
    confirmId?: string;
    keepId?: string;
}

/**
 * Presentational two-button confirmation prompt — a destructive "confirm" over a neutral "keep".
 * Owns no state: the caller decides when to show it and what each button does. Reusable across the
 * scan2auth single/bulk modals and any other destructive flow.
 */
export const ConfirmActionDialog = (props: ConfirmActionDialogProps): JSX.Element => (
    <div className="text-center">
        <p className="mb-2"><strong>{props.title}</strong></p>
        <p className="text-muted mb-3">{props.body}</p>
        <div className={ACTION_STACK_CLASS}>
            <Button
                id={props.confirmId}
                size="lg"
                label={props.confirmLabel}
                variant="base"
                style={destructiveButtonStyle}
                disabled={props.submitting}
                onClick={props.onConfirm}
            />
            <Button
                id={props.keepId}
                className="mt-2"
                size="lg"
                label={props.keepLabel}
                variant="base"
                onClick={props.onKeep}
            />
        </div>
    </div>
);
